import React, { useState } from 'react';
import { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalBody from '../../Modal/ModalBody';
import ModalButtons from '../../Modal/ModalButtons';
import { postAccountAddress } from '../../../store/actions/account/accountActions';
import { getCurrentAccountUid } from '../../../store/selectors/accountSelectors';
import SectionLoader from '../../Loader/SectionLoader';
import { getStatesOptions } from '../../../util/helpers/addressHelper';
import {
  addNewAddressValidationSchema,
  addNewBankAddressValidationSchema,
} from '../../../validation/addAddressValidationSchema';
import { USA_COUNTRY_ISO3CODE } from '../../../util/constants';
import { selectStates } from '../../../store/selectors/commonSelectors';
import DeliveryAddressForm from '../../AddressForm/DeliveryAddressForm';
import { ADDRESS_TAG_TYPES } from '../../../util/enum/api/addressTagType';
import Note from '../../Notes/Note';

const uLayoutStyle = css`
  height: 100%;

  form {
    height: 100%;
  }
`;

const AddDeliveryAddress = ({
  onButtonClick,
  handleNext,
  setError,
  error,
  isAddingCCFlow,
  bankName,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const accountUid = useSelector(getCurrentAccountUid);

  const states = useSelector(selectStates);
  const STATES_OPTIONS = getStatesOptions(states);

  const handleSubmitAddress = (values) => {
    setError('');
    const addressPayload = {
      Street: values.AddressLine2
        ? `${values.AddressLine} ${values.AddressLine2}`
        : values.AddressLine,
      City: values.City,
      PostalCode: values.PostalCode,
      State: values.StateRegion,
      CountryIso3Code: isAddingCCFlow
        ? values.CountryIso3Code
        : USA_COUNTRY_ISO3CODE,
      ...(bankName
        ? { TagType: ADDRESS_TAG_TYPES.BANK_ACCOUNT_STATEMENT }
        : { TagType: values.TagType, TagNote: values.CustomTagName }),
    };
    const submittedAddress = {
      AddressLine: values.AddressLine,
      AddressLine2: values.AddressLine2,
      City: values.City,
      StateRegion: values.StateRegion,
      PostalCode: values.PostalCode,
    };

    dispatch(
      postAccountAddress({
        accountUid,
        data: {
          ...addressPayload,
        },
        handleNext: (responseData) =>
          handleNext(responseData, submittedAddress),
        onButtonClick,
        setIsLoading,
        setError,
      }),
    );
  };

  return (
    <SectionLoader isLoading={isLoading}>
      <ModalBody css={uLayoutStyle}>
        <Formik
          initialValues={{
            CountryIso3Code: USA_COUNTRY_ISO3CODE,
            AddressLine: '',
            AddressLine2: '',
            City: '',
            StateRegion: '',
            PostalCode: '',
            TagType: '',
            TagNote: '',
          }}
          onSubmit={handleSubmitAddress}
          validationSchema={
            bankName
              ? addNewBankAddressValidationSchema
              : addNewAddressValidationSchema
          }
          enableReinitialize
        >
          {({ isValid, values, setFieldValue }) => (
            <Form>
              <DeliveryAddressForm
                stateOptions={STATES_OPTIONS}
                setFieldValue={setFieldValue}
                {...values}
                // selectedTag={selectedTag}
                // setSelectedTag={setSelectedTag}
                // selectedTag={values.TagType}
                values={values}
                isAddingCCFlow={isAddingCCFlow}
                bankName={bankName}
              />
              {error && <Note isError text={error} marginTop={8} />}
              <ModalButtons
                isVertical
                showOnlySecondary
                marginTop
                secondaryButtonProps={{
                  type: 'submit',
                  textTransform: 'capitalize',
                  label: t('buyWizard.saveAndContinue'),
                  disabled: !isValid,
                }}
              />
            </Form>
          )}
        </Formik>
      </ModalBody>
    </SectionLoader>
  );
};

AddDeliveryAddress.propTypes = {
  onButtonClick: PropTypes.func,
  handleNext: PropTypes.func,
  setError: PropTypes.func,
  error: PropTypes.string,
  isAddingCCFlow: PropTypes.bool,
  bankName: PropTypes.string,
};

export default AddDeliveryAddress;
